// @ts-nocheck
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import { useContext } from "react";

export default () => {
    return useContext(ProductContext);
};
